import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { FeUtil, API, TYPE } from '../../../hezky-routes';
import { StandardResponse } from '../../../types';

@Injectable({
  providedIn: 'root'
})
export class IncidentService {
  constructor(public feUtil: FeUtil) { }

  private commonDropDowns: { label: string, value: string }[] = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' }
  ];

  public storageFormConfig: TYPE.TrIncidentFormConfig[] = [
    {
      form_name: 'Incident Details',
      form_type: 'prod',
      fields: [
        {
          name: 'isImpacted', label: 'Were any products impacted?', type: 'select', placeholder: 'Select an option',
          options: this.commonDropDowns,
          validators: ['required']
        },
        {
          name: 'shiftedYesNo', label: 'Was the Impacted Product(s) immediately shifted to alternate Area?', type: 'select', placeholder: 'Select an option',
          options: this.commonDropDowns,
          validators: ['required']
        },
        { name: 'immedCorrDetail', label: 'Details', type: 'textarea', placeholder: 'Enter the details', validators: ['required', 'minlength:3'] },
      ],
    },
    {
      form_name: 'Investigation & CAPA',
      form_type: 'capa',
      fields: [
        { name: 'reasonForExcursion', label: 'Reason for Excursion', type: 'select', placeholder: 'Enter the details', validators: ['required', 'minlength:3'] },
        { name: 'details', label: 'Please mention the details & cause', type: 'textarea', placeholder: 'Enter the details', validators: ['required', 'minlength:3'] },
        { name: 'capaImpDate', label: 'Capa Implementation Date', type: 'date', placeholder: 'Select capa implementation date', validators: ['required'] },
        { name: 'comment', label: 'Comment', type: 'textarea', placeholder: 'Enter the details', validators: ['required', 'minlength:3'] },
      ]
    },
    {
      form_name: 'Evaluation & Disposition',
      form_type: 'eval',
      fields: [
        { name: 'productDisposition', label: 'Product Disposition', type: 'text', placeholder: 'Enter the details', disabled: true },
        { name: 'impactAssessment', label: 'Impact Assessment', type: 'textarea', placeholder: 'Enter the details', validators: ['required', 'minlength:3'] },
      ]
    }
  ];

  public transportFormConfig: TYPE.TrIncidentFormConfig[] = [
    {
      form_name: 'Incident Details',
      form_type: 'prod',
      fields: [
        {
          name: 'isImpacted', label: 'Were any products impacted?', type: 'select', placeholder: 'Select an option',
          options: this.commonDropDowns,
          validators: ['required']
        },
        {
          name: 'shiftedYesNo', label: 'Was the Impacted Product(s) immediately shifted to alternate Area?', type: 'select', placeholder: 'Select an option',
          options: this.commonDropDowns,
          validators: ['required']
        },
        {
          name: 'shiftedTo', label: 'Shifted to', type: 'radio', placeholder: 'Select an option',
          validators: ['required']
        },
        { name: 'shiftTargetName', label: 'Shifted to detail', type: 'text', placeholder: 'Enter the details', validators: ['required'] },
        { name: 'shiftDatetime', label: 'Date & Time Shifted', type: 'date', placeholder: 'Select date & time', validators: ['required'] },
        { name: 'immedCorrDetail', label: 'Details', type: 'textarea', placeholder: 'Enter the details', validators: ['required', 'minlength:3'] },
      ],
    },
    {
      form_name: 'Investigation & CAPA',
      form_type: 'capa',
      fields: [
        { name: 'isVehicleSealed', label: 'Was the vehicle sealed?', type: 'radio', placeholder: 'Enter the details', options: this.commonDropDowns, validators: ['required'] },
        { name: 'isCoolingWorking', label: 'Was the cooling working when vehicle was received and being updated at CFA/HUB ?', type: 'radio', placeholder: 'Enter the details', options: this.commonDropDowns, validators: ['required'] },
        { name: 'isMalfunctionReported', label: 'Discuss with driver to find out if vehicle or cooling unit malfunctioned during transit?', type: 'radio', placeholder: 'Enter the details', options: this.commonDropDowns, validators: ['required'] },
        { name: 'reasonForExcursion', label: 'Reason for Excursion', type: 'textarea', placeholder: 'Enter the details', validators: ['required', 'minlength:3'] },
        { name: 'capaImpDate', label: 'Capa Implementation Date', type: 'date', placeholder: 'Select capa implementation date', validators: ['required'] },
        { name: 'details', label: 'Comment', type: 'textarea', placeholder: 'Enter the details', validators: ['required', 'minlength:3'] },
      ]
    },
    {
      form_name: 'Evaluation & Disposition',
      form_type: 'eval',
      fields: [
        { name: 'productDisposition', label: 'Product Disposition', type: 'text', placeholder: 'Enter the details', disabled: true },
        { name: 'impactAssessment', label: 'Impact Assessment', type: 'textarea', placeholder: 'Enter the details', validators: ['required', 'minlength:3'] },
      ]
    }
  ];

  // **************************************************** STORAGE INCIDENT API CALLS & HELPER FUNCTIONS ****************************************************
  
  STORAGE = {
    List: (payload: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.get<StandardResponse<any>>(API.INCIDENTS.STORAGE.LIST, payload);
    },
    byId: (id: string): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.get<StandardResponse<any>>(API.INCIDENTS.STORAGE.BY_ID(id));
    },
    updateIncident: (incident_id: string, payload: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.patch<StandardResponse<any>>(API.INCIDENTS.STORAGE.UPDATE_INCIDENT(incident_id), payload);
    },
    getFormData: (payload: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.post<StandardResponse<any>>(API.INCIDENTS.STORAGE.GET_FORM_DATA, payload);
    },
    getResetFormDataByLogId: (logId: number): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.get<StandardResponse<any>>(API.INCIDENTS.STORAGE.GET_RESET_FORM_DATA_BY_LOG_ID(logId));
    },
    history: (id: number | string): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.get<StandardResponse<any>>(API.INCIDENTS.STORAGE.GET_INCIDENT_HISTORY(id));
    },
    logs: (incident_id: number | string): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.get<StandardResponse<any>>(API.INCIDENTS.STORAGE.GET_INCIDENT_LOG(incident_id));
    },
    uploadCapaFile: (formData: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.postFile<StandardResponse<any>>(API.INCIDENTS.STORAGE.CAPA_FILE_UPLOAD, formData);
    },
    submitForm: (data: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.post<StandardResponse<any>>(API.INCIDENTS.STORAGE.FORM_SUBMISSION, data);
    },
    formAction: (data: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.post<StandardResponse<any>>(API.INCIDENTS.STORAGE.FORM_ACTION, data);
    },
    resetForm: (data: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.post<StandardResponse<any>>(API.INCIDENTS.STORAGE.RESUBMIT_INCIDENT, data);
    },
    saveProduct: (data: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.post<StandardResponse<any>>(API.INCIDENTS.STORAGE.SAVE_PRODUCT, data);
    },
    comment: (payload: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.post<StandardResponse<any>>(API.INCIDENTS.STORAGE.COMMENT, payload);
    }
  }

  // **************************************************** TRANSPORT INCIDENT FORM API CALLS ****************************************************

  TRANSPORT = {
    list: (payload: any): Observable<any> => {
      return this.feUtil.httpSvc.get<any>(API.INCIDENTS.TRANSPORT.LIST, payload);
    },
    byId: (id: string): Observable<any> => {
      return this.feUtil.httpSvc.get<any>(API.INCIDENTS.TRANSPORT.BY_ID(id));
    },
    getChildIncidents: (params: { leg_id: string } | { status: string } | {}): Observable<any> => {
      return this.feUtil.httpSvc.get<any>(API.INCIDENTS.TRANSPORT.GET_CHILD_INCIDENTS, params);
    },
    updateIncident: (incident_id: string, payload: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.patch<StandardResponse<any>>(API.INCIDENTS.TRANSPORT.UPDATE_INCIDENT(incident_id), payload);
    },
    getFormData: (payload: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.post<StandardResponse<any>>(API.INCIDENTS.TRANSPORT.GET_FORM_DATA, payload);
    },
    getResetFormDataByLogId: (logId: number): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.get<StandardResponse<any>>(API.INCIDENTS.TRANSPORT.GET_RESET_FORM_DATA_BY_LOG_ID(logId));
    },
    history: (id: number | string): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.get<StandardResponse<any>>(API.INCIDENTS.TRANSPORT.GET_HISTORY_DATA_BY_ID(id));
    },
    logs: (id: number | string): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.get<StandardResponse<any>>(API.INCIDENTS.TRANSPORT.GET_INCIDENT_DETAILS_LOG(id));
    },
    uploadCapaFile: (formData: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.postFile<StandardResponse<any>>(API.INCIDENTS.TRANSPORT.CAPA_FILE_UPLOAD, formData);
    },
    submitForm: (data: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.post<StandardResponse<any>>(API.INCIDENTS.TRANSPORT.FORM_SUBMISSION, data);
    },
    formAction: (data: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.post<StandardResponse<any>>(API.INCIDENTS.TRANSPORT.FORM_ACTION, data);
    },
    resetForm: (data: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.post<StandardResponse<any>>(API.INCIDENTS.TRANSPORT.RESUBMIT_INCIDENT, data);
    },
    requestFormExtension: (data: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.post<StandardResponse<any>>(API.INCIDENTS.REQUEST_EXTENSION, data);
    },
    saveProduct: (data: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.post<StandardResponse<any>>(API.INCIDENTS.TRANSPORT.SAVE_PRODUCT, data);
    },
    comment: (payload: any): Observable<StandardResponse<any>> => {
      return this.feUtil.httpSvc.post<StandardResponse<any>>(API.INCIDENTS.TRANSPORT.COMMENT, payload);
    }
  }

  // **************************************************** COMMON METHODS **********************************************************

  assignToHandler(payload: any, username: string, type: 'storage' | 'transport'): Observable<boolean> {
    let id = type === 'storage' ? payload.incident_id : payload.leg_id;
    if (!id) return throwError(() => new Error('Incident ID or Leg ID is required'));
    return new Observable((observer) => {
      const assignIncident = () => {
        const updateIncident$ = type === 'storage' ?
         this.STORAGE.updateIncident(id, payload) : this.TRANSPORT.updateIncident(id, payload);
        updateIncident$.subscribe({
          next: (res: any) => {
            if (res?.status === 200) {
              this.feUtil.message.success(`Incident assigned successfully to ${username}`, { nzDuration: 2000 });
            }
            observer.next(true);
          },
          error: () => observer.next(false),
        });
      };
      this.feUtil.modalSvc.confirm({
        nzTitle: 'Confirm',
        nzContent: `Are you sure you want to ${payload.assigned_to ? `assign this incident to ${username}` : 'unassign this incident'}?`,
        nzOnOk: assignIncident,
        nzOnCancel: () => observer.next(false),
      });
    });
  }

  acknowledgeIncidentHandler(incident_id: string): Observable<boolean> {
    return new Observable((observer) => {
      const acknowledgeIncident = () => {
        const updateIncident$ = this.feUtil.appId === 1 ?
          this.STORAGE.updateIncident(incident_id, { acknowledged: true }) :
          this.TRANSPORT.updateIncident(incident_id, { acknowledged: true });
        updateIncident$.subscribe({
          next: (res: any) => {
            if (res?.status === 200) this.feUtil.message.success(`Incident acknowledged successfully`, { nzDuration: 2000 });
            observer.next(true);
          },
          error: () => observer.next(false),
        });
      };

      this.feUtil.modalSvc.confirm({
        nzTitle: 'Confirm',
        nzContent: `Are you sure you want to acknowledge this incident? This action cannot be undone.`,
        nzOnOk: acknowledgeIncident,
        nzOnCancel: () => observer.next(false),
      });
    });
  }

  updateIncidentStatus(incident_id: string, status: string): Observable<boolean> {
    return new Observable((observer) => {
      const updateIncidentStatus = () => {
        const updateIncident$ = this.feUtil.appId === 1 ?
         this.STORAGE.updateIncident(incident_id, { status: status }) : this.TRANSPORT.updateIncident(incident_id, { status: status });
        updateIncident$.subscribe({
          next: (res: any) => {
            if (res?.status === 200) {
              this.feUtil.message.success(`Incident status updated successfully`, { nzDuration: 2000 });
            }
            observer.next(true);
          },
          error: () => observer.next(false),
        });
      };
      this.feUtil.modalSvc.confirm({
        nzTitle: 'Confirm',
        nzContent: `Are you sure you want to update the status of this incident to ${status}?`,
        nzOnOk: updateIncidentStatus,
        nzOnCancel: () => observer.next(false),
      });
    });
  }

  // **************************************************** FORMS API CALLS **************************************************************

  submitIncidentForm(data: any): Observable<any> {
    if (this.feUtil.appId === 2) {
      return this.TRANSPORT.submitForm(data);
    } else if (this.feUtil.appId === 1) {
      return this.STORAGE.submitForm(data);
    } else {
      return throwError(() => new Error('Unknown application type for incident form submission'));
    }
  }

  incidentFormAction(data: any): Observable<any> {
    if (this.feUtil.appId === 2) {
      return this.TRANSPORT.formAction(data);
    } else if (this.feUtil.appId === 1) {
      return this.STORAGE.formAction(data);
    } else {
      return throwError(() => new Error('Unknown application type for incident form submission'));
    }
  }

  getFormData(data: any): Observable<any> {
    if (this.feUtil.appId === 2) {
      return this.TRANSPORT.getFormData(data);
    } else if (this.feUtil.appId === 1) {
      return this.STORAGE.getFormData(data);
    } else {
      return throwError(() => new Error('Unknown application type for incident form data fetching'));
    }
  }

  getResetFormDataByLogId(logId: number): Observable<any> {
    if (this.feUtil.appId === 2) {
      return this.TRANSPORT.getResetFormDataByLogId(logId);
    } else if (this.feUtil.appId === 1) {
      return this.STORAGE.getResetFormDataByLogId(logId);
    } else {
      return throwError(() => new Error('Unknown application type for incident form data fetching'));
    }
  }

  uploadCapaFile(formData: any): Observable<any> {
    if (this.feUtil.appId === 2) {
      return this.TRANSPORT.uploadCapaFile(formData);
    } else if (this.feUtil.appId === 1) {
      return this.STORAGE.uploadCapaFile(formData);
    } else {
      return throwError(() => new Error('Unknown application type for incident form data fetching'));
    }
  }

  getHistoryData(id: number | string): Observable<any> {
    if (this.feUtil.appId === 2) {
      return this.TRANSPORT.history(id);
    } else if (this.feUtil.appId === 1) {
      return this.STORAGE.history(id);
    } else {
      return throwError(() => new Error('Unknown application type for incident form data fetching'));
    }
  }

    getLogData(id: number | string): Observable<any> {
    if (this.feUtil.appId === 2) {
      return this.TRANSPORT.logs(id);
    } else if (this.feUtil.appId === 1) {
      return this.STORAGE.logs(id);
    } else {
      return throwError(() => new Error('Unknown application type for incident form data fetching'));
    }
  }

  resubmitIncident(payload: any): Observable<any> {
    if (this.feUtil.appId === 2) {
      return this.TRANSPORT.resetForm(payload);
    } else if (this.feUtil.appId === 1) {
      return this.STORAGE.resetForm(payload);
    } else {
      return throwError(() => new Error('Unknown application type for incident form data fetching'));
    }
  }

  saveProduct(payload: any): Observable<any> {
    if (this.feUtil.appId === 2) {
      return this.TRANSPORT.saveProduct(payload);
    } else if (this.feUtil.appId === 1) {
      return this.STORAGE.saveProduct(payload);
    } else {
      return throwError(() => new Error('Unknown application type for incident form data fetching'));
    }
  }

  comment(payload: any): Observable<any> {
    if (this.feUtil.appId === 2) {
      return this.TRANSPORT.comment(payload);
    } else if (this.feUtil.appId === 1) {
      return this.STORAGE.comment(payload);
    } else {
      return throwError(() => new Error('Unknown application type for incident form data fetching'));
    }
  }

  loadIncidentLocWiseUsers(users: any[], list: any[]): any[] {
    if (!list?.length) return [];
    const locationUserMap: Record<string, any[]> = {};
    const appId = this.feUtil.appId;
    for (const user of users) {
      if (!user.location_ids) continue;
      for (const locId of user.location_ids.split(',').map((id: string) => id.trim())) {
        if (!locationUserMap[locId]) {
          locationUserMap[locId] = [];
        }
        locationUserMap[locId].push(user);
      }
    }
    return list.map((incident) => {
      let assignedUsers: any[] = [];
      if (appId === 1) {
        const locId = incident?.location_id;
        if (!locId) assignedUsers = users;
        else assignedUsers = locationUserMap[String(locId)] || [];
      } 
      if (appId === 2) {
        const endLocId = incident.endLocation?.id;
        if (!endLocId) assignedUsers = users;
        else assignedUsers = locationUserMap[String(endLocId)] || [];
      }
      incident.assigned_to_users = assignedUsers;
      return incident;
    });
  }
}
